import {FC} from 'react'
import {Spinner} from 'react-bootstrap'

export type UploadContactFooterProps = {
  allowedNext?: boolean
  isLoading?: boolean
  isLast?: boolean
  handleClose: () => void
  handleNext: () => void
  handleBack?: () => void
}
const UploadContactFooter: FC<UploadContactFooterProps> = (props) => {
  const {allowedNext, isLoading, isLast, handleClose, handleNext, handleBack} = props
  return (
    <div className='d-flex justify-content-end mt-5'>
      {handleBack ? (
        <div id='kt_drawer_chat_close'>
          <button
            type='button'
            onClick={handleBack}
            className='btn btn-sm gray_bg_purple me-2 w-100px p-3 fw-500 me-2'
          >
            Back
          </button>
        </div>
      ) : (
        <div id='kt_drawer_chat_close'>
          <button
            type='button'
            onClick={handleClose}
            className='btn btn-sm gray_bg_purple me-2 w-100px p-3 fw-500 me-2'
          >
            Cancel
          </button>
        </div>
      )}

      <button
        className='btn btn-sm btn-light btn-primary fw-500   w-100px p-3 border-primary'
        disabled={!allowedNext}
        onClick={handleNext}
      >
        {isLoading ? (
          <Spinner size='sm' animation='grow' />
        ) : (
          <span className='indicator-label'>{isLast ? 'Submit' : 'Next'}</span>
        )}
        <div></div>
      </button>
    </div>
  )
}

UploadContactFooter.defaultProps = {
  allowedNext: false,
  isLoading: false,
  isLast: false,
}

export default UploadContactFooter
